import { makeStyles, Typography } from "@material-ui/core"
import React, { FC, useState } from "react"
import { useNavigation } from "../../hooks/useNavigation"
import { useUser } from "../../hooks/useUser"
import { ComponentHeaderHeight } from "../../utils/constants"
import { colors } from "../../utils/theme"
import { GhostButton } from "../atoms/button/Button"
import ChevronLeftIcon from "../atoms/ChevronLeftIcon"
import EditOrgLocationDialog from "../molecules/EditOrgLocationDialog"
import EditOrgNameDialog from "../molecules/EditOrgNameDialog"
import { HeaderHeight } from "../molecules/Header"

const useStyles = makeStyles((theme) => ({
  organizationSettings: {
    paddingTop: HeaderHeight,
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  header: {
    height: ComponentHeaderHeight,
    maxWidth: 1440,
    margin: "0 auto",
  },
  line: {
    borderBottom: `1px solid ${colors.neutral.clay}`,
  },
  content: {
    padding: theme.spacing(4),
    maxWidth: 1440,
    margin: "0 auto",
  },
  chevron: {
    marginRight: 4,
  },
  title: {
    color: colors.neutral.denim,
  },
  navigation: {
    height: 92,
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    paddingLeft: theme.spacing(3),
    outline: "none",
  },
  settings: {
    marginTop: theme.spacing(3),
  },
  setting: {
    height: 68,
    width: 842,
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${colors.neutral.clay}`,
  },
  settingTitle: {
    width: 217,
    fontWeight: 700,
    color: colors.neutral.denim,
  },
  settingValue: {
    color: colors.neutral.denim,
  },
  rest: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
}))

const OrganizationSettings: FC = () => {
  const classes = useStyles()
  const { user } = useUser()
  const { toMyOrg } = useNavigation()
  const [openEditName, setOpenEditName] = useState<boolean>(false)
  const [openEditLocation, setOpenEditLocation] = useState<boolean>(false)

  const organization = user?.organizations?.[0]

  return (
    <div className={classes.organizationSettings}>
      <div className={classes.header}>
        <button className={classes.navigation} onClick={toMyOrg}>
          <ChevronLeftIcon className={classes.chevron} />
          <Typography variant="h2" className={classes.title}>
            Organization Settings
          </Typography>
        </button>
      </div>
      <div className={classes.line} />
      <div className={classes.content}>
        <div className={classes.settings}>
          <div className={classes.setting}>
            <Typography variant="body1" className={classes.settingTitle}>
              Organization Name
            </Typography>
            <div className={classes.rest}>
              <Typography variant="body1" className={classes.settingValue}>
                {organization?.name}
              </Typography>
              <GhostButton onClick={() => setOpenEditName(true)}>
                Edit
              </GhostButton>
            </div>
          </div>
          <div className={classes.setting}>
            <Typography variant="body1" className={classes.settingTitle}>
              Location
            </Typography>
            <div className={classes.rest}>
              <Typography variant="body1" className={classes.settingValue}>
                {organization?.location}
              </Typography>
              <GhostButton onClick={() => setOpenEditLocation(true)}>
                Edit
              </GhostButton>
            </div>
          </div>
        </div>
      </div>

      <EditOrgNameDialog
        open={openEditName}
        onClose={() => setOpenEditName(false)}
      />
      <EditOrgLocationDialog
        open={openEditLocation}
        onClose={() => setOpenEditLocation(false)}
      />
    </div>
  )
}

export default OrganizationSettings
